import { render } from "./section-images-grid-second.vue?vue&type=template&id=38f5b8ca"
import script from "./section-images-grid-second.vue?vue&type=script&lang=js"
export * from "./section-images-grid-second.vue?vue&type=script&lang=js"

import "./section-images-grid-second.vue?vue&type=style&index=0&id=38f5b8ca&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__